module.exports = __webpack_public_path__ + "static/media/update.86c37c8d.svg";